// ─────────────────────────────────────────────────────────────────────────────
// AccessTab.js — the PERMISSIONS list (resource → access level).
// ─────────────────────────────────────────────────────────────────────────────
import styles from "../UserDetailModal.module.css";

// "None" reads as muted; everything else is an active (green) grant.
const isDenied = (level) => level.toLowerCase() === "none";

export default function AccessTab({ detail }) {
  return (
    <div className={styles.tab}>
      <div className={styles.sectionLabel}>Permissions</div>
      <div className={styles.list}>
        {detail.permissions.map(({ label, level }) => (
          <div key={label} className={styles.permRow}>
            <span className={styles.permLabel}>{label}</span>
            <span
              className={`${styles.permLevel} ${isDenied(level) ? styles.permDenied : ""}`}
            >
              {level}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
